import { cn } from "@/lib/utils";
import Spinner from "@patient-watch/ui/spinner";

interface AuthLoadingStateProps {
    message: string;
    className?: string;
}

/** Shared centred spinner + message for every auth loading screen. */
export function AuthLoadingState({ message, className }: AuthLoadingStateProps) {
    return (
        <div className={cn("flex flex-col justify-center items-center gap-4 py-6", className)} role="status">
            <Spinner />
            <p className="text-slate-600 dark:text-slate-300 text-md text-center">{message}</p>
        </div>
    );
}
